import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-318fb7d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "post__main" }
const _hoisted_3 = { class: "post__head" }
const _hoisted_4 = {
  key: 0,
  class: "post__rank post__rank--staff"
}
const _hoisted_5 = {
  key: 1,
  class: "post__rank"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 3,
  class: "post__pin"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "post__body" }
const _hoisted_10 = { class: "post__actions" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "post__spacer" }, null, -1))
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "post__replies"
}
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "post__main" }
const _hoisted_18 = { class: "post__head" }
const _hoisted_19 = {
  key: 0,
  class: "post__rank post__rank--staff"
}
const _hoisted_20 = {
  key: 1,
  class: "post__rank"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "post__body post__body--sm" }
const _hoisted_24 = { class: "post__actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "post__spacer" }, null, -1))
const _hoisted_27 = ["title", "onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onSubmit"]
const _hoisted_30 = ["placeholder", "disabled"]
const _hoisted_31 = ["disabled", "title"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

import { computed, nextTick, ref } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import { Actions } from '@/store/enums/StoreEnums';
import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { useCourseI18n } from '../course';


export default /*#__PURE__*/_defineComponent({
  props: {
    feed: null,
    lessonId: null,
    pinned: { type: Boolean }
  },
  emits: ["changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changed'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  feed: any
  lessonId: number
  pinned?: boolean
}



// "changed": algo mudou no servidor e a aula precisa ser recarregada


const store = useStore();
const { tc } = useCourseI18n();

const currentUser = computed(() => store.getters.currentUser);
const comments = computed<any[]>(() => props.feed.comments || []);

const REACTIONS = [
  { key: 'love', icon: 'heart' },
  { key: 'fire', icon: 'rocket' },
  { key: 'like', icon: 'thumb' },
  { key: 'eye', icon: 'ghost' },
];

const showReplies = ref(false);
const reply = ref('');
const replying = ref(false);
const replyInput = ref<HTMLInputElement | null>(null);
const reacting = ref(false);

const fromNow = (date: string) => moment(date).fromNow();
const badgeSrc = (user: any) => `/media/logos/badges/${user?.user_patent?.icon}`;

// Mesma regra otimista do widget de feed: troca a reação do usuário e ajusta os contadores
const toggleReaction = (target: any, react: string) => {
  const current = target.current_user_reaction;
  if (current === react) {
    target[react] = Math.max(Number(target[react] || 0) - 1, 0);
    target.current_user_reaction = '';
  } else {
    target[react] = Number(target[react] || 0) + 1;
    if (current) target[current] = Math.max(Number(target[current] || 0) - 1, 0);
    target.current_user_reaction = react;
  }
};

const react = async (type: 'hacktivity' | 'comment', target: any, id: number, key: string) => {
  if (reacting.value || !target) return;
  reacting.value = true;
  toggleReaction(target, key);
  try {
    await store.dispatch(Actions.REACT, { type, react: key, id });
  } finally {
    reacting.value = false;
  }
};

const openReplies = async (mention?: string) => {
  showReplies.value = true;
  if (mention) reply.value = `@${mention} `;
  await nextTick();
  replyInput.value?.focus();
};

const sendReply = async () => {
  if (!reply.value.trim() || replying.value) return;
  replying.value = true;
  try {
    await store.dispatch(Actions.COMMENT, { id: props.feed.id, message: reply.value.trim() });
    reply.value = '';
    emit('changed');
  } finally {
    replying.value = false;
  }
};

const confirmDelete = async () => {
  const result = await Swal.fire({
    text: tc('delete_confirm'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: tc('delete'),
    cancelButtonText: tc('cancel'),
  });
  return result.isConfirmed;
};

const deletePost = async () => {
  if (!(await confirmDelete())) return;
  await store.dispatch(Actions.DELETE_HACKTIVITY, { id: props.feed.id, lessonId: props.lessonId });
  emit('changed');
};

const deleteComment = async (comment: any) => {
  if (!(await confirmDelete())) return;
  await store.dispatch(Actions.DELETE_COMMENT, { comment_id: comment.id, hacktivity_id: comment.commentable_id ?? props.feed.id });
  emit('changed');
};

const togglePin = async () => {
  await store.dispatch(Actions.FIXED_HACKTIVITY, { id: props.feed.id, lessonId: props.lessonId });
  emit('changed');
};

const repliesLabel = computed(() => {
  const count = comments.value.length;
  if (!count) return tc('reply');
  return count === 1 ? tc('one_reply') : tc('replies_count', { n: count });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["post", { 'post--pinned': __props.pinned }])
  }, [
    _createVNode(_component_router_link, {
      to: { name: 'profile-user', params: { id: __props.feed.user?.id } },
      class: "post__avatar"
    }, {
      default: _withCtx(() => [
        (__props.feed.user?.avatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.feed.user.avatar,
              alt: __props.feed.user?.nick
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { name: 'profile-user', params: { id: __props.feed.user?.id } },
          class: "post__nick"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.feed.user?.nick || 'No nick'), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        (__props.feed.user?.is_admin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(tc)('staff')), 1))
          : (__props.feed.user?.user_patent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("img", {
                  src: badgeSrc(__props.feed.user),
                  alt: ""
                }, null, 8, _hoisted_6),
                _createTextVNode(_toDisplayString(__props.feed.user.user_patent.name), 1)
              ]))
            : _createCommentVNode("", true),
        (__props.feed.user?.is_elite)
          ? (_openBlock(), _createBlock(HcIcon, {
              key: 2,
              name: "award",
              size: 15,
              class: "post__elite",
              title: 'Elite Member'
            }))
          : _createCommentVNode("", true),
        (__props.pinned)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createVNode(HcIcon, {
                name: "pin",
                size: 13
              }),
              _createTextVNode(_toDisplayString(_unref(tc)('pinned')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("time", {
          title: __props.feed.created_at
        }, _toDisplayString(fromNow(__props.feed.created_at)), 9, _hoisted_8)
      ]),
      _createElementVNode("p", _hoisted_9, _toDisplayString(__props.feed.headline), 1),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(REACTIONS, (reaction) => {
          return _createElementVNode("button", {
            key: reaction.key,
            type: "button",
            class: _normalizeClass(["post__react", [`post__react--${reaction.key}`, { 'post__react--on': __props.feed.reaction?.current_user_reaction === reaction.key }]]),
            onClick: ($event: any) => (react('hacktivity', __props.feed.reaction, __props.feed.id, reaction.key))
          }, [
            _createVNode(HcIcon, {
              name: reaction.icon,
              size: 15
            }, null, 8, ["name"]),
            _createTextVNode(_toDisplayString(__props.feed.reaction?.[reaction.key] ?? 0), 1)
          ], 10, _hoisted_11)
        }), 64)),
        _hoisted_12,
        (_unref(currentUser)?.is_admin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "post__react",
              title: __props.pinned ? _unref(tc)('unpin') : _unref(tc)('pin'),
              onClick: togglePin
            }, [
              _createVNode(HcIcon, {
                name: "pin",
                size: 15
              })
            ], 8, _hoisted_13))
          : _createCommentVNode("", true),
        (__props.feed.user?.id === _unref(currentUser)?.id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "post__react",
              title: _unref(tc)('delete'),
              onClick: deletePost
            }, [
              _createVNode(HcIcon, {
                name: "trash",
                size: 15
              })
            ], 8, _hoisted_14))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["post__react", { 'post__react--on': showReplies.value }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showReplies.value ? (showReplies.value = false) : openReplies()))
        }, [
          _createVNode(HcIcon, {
            name: "chat",
            size: 15
          }),
          _createTextVNode(_toDisplayString(_unref(repliesLabel)), 1)
        ], 2)
      ]),
      (showReplies.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comments), (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                key: comment.id,
                class: "reply"
              }, [
                _createVNode(_component_router_link, {
                  to: { name: 'profile-user', params: { id: comment.user?.id } },
                  class: "post__avatar post__avatar--sm"
                }, {
                  default: _withCtx(() => [
                    (comment.user?.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: comment.user.avatar,
                          alt: comment.user?.nick
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_router_link, {
                      to: { name: 'profile-user', params: { id: comment.user?.id } },
                      class: "post__nick"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(comment.user?.nick || 'No nick'), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (comment.user?.is_admin)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(tc)('staff')), 1))
                      : (comment.user?.user_patent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            _createElementVNode("img", {
                              src: badgeSrc(comment.user),
                              alt: ""
                            }, null, 8, _hoisted_21),
                            _createTextVNode(_toDisplayString(comment.user.user_patent.name), 1)
                          ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("time", {
                      title: comment.created_at
                    }, _toDisplayString(fromNow(comment.created_at)), 9, _hoisted_22)
                  ]),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(comment.message), 1),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(REACTIONS, (reaction) => {
                      return _createElementVNode("button", {
                        key: reaction.key,
                        type: "button",
                        class: _normalizeClass(["post__react post__react--sm", [`post__react--${reaction.key}`, { 'post__react--on': comment.reactions?.current_user_reaction === reaction.key }]]),
                        onClick: ($event: any) => (react('comment', comment.reactions, comment.id, reaction.key))
                      }, [
                        _createVNode(HcIcon, {
                          name: reaction.icon,
                          size: 14
                        }, null, 8, ["name"]),
                        _createTextVNode(_toDisplayString(comment.reactions?.[reaction.key] ?? 0), 1)
                      ], 10, _hoisted_25)
                    }), 64)),
                    _hoisted_26,
                    (comment.user?.id === _unref(currentUser)?.id || _unref(currentUser)?.is_admin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "post__react post__react--sm",
                          title: _unref(tc)('delete'),
                          onClick: ($event: any) => (deleteComment(comment))
                        }, [
                          _createVNode(HcIcon, {
                            name: "trash",
                            size: 14
                          })
                        ], 8, _hoisted_27))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "post__react post__react--sm",
                      onClick: ($event: any) => (openReplies(comment.user?.nick))
                    }, [
                      _createVNode(HcIcon, {
                        name: "reply",
                        size: 14
                      }),
                      _createTextVNode(_toDisplayString(_unref(tc)('reply')), 1)
                    ], 8, _hoisted_28)
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("form", {
              class: "post__reply-form",
              onSubmit: _withModifiers(sendReply, ["prevent"])
            }, [
              _withDirectives(_createElementVNode("input", {
                ref_key: "replyInput",
                ref: replyInput,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reply).value = $event)),
                type: "text",
                placeholder: _unref(tc)('reply_placeholder'),
                disabled: replying.value
              }, null, 8, _hoisted_30), [
                [_vModelText, reply.value]
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "lp-btn lp-btn--sm lp-btn--outline",
                disabled: replying.value || !reply.value.trim(),
                title: _unref(tc)('reply')
              }, [
                (replying.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                  : (_openBlock(), _createBlock(HcIcon, {
                      key: 1,
                      name: "send",
                      size: 15
                    }))
              ], 8, _hoisted_31)
            ], 40, _hoisted_29)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})